<template>
  <section class="ecom price-lock">
    <img class="ecom price-lock__img" :src="lock" />
    <p>Prices and availability are subject to change, so secure this dumpster reservation for your project now.</p>
  </section>
</template>

<script>
import config from '@/config'

const { cdn } = config
export default {
  data () {
    return {
      lock: `${cdn}icons-lock-rate-FOMO.svg`
    }
  }
}
</script>
